// Латинские двойники кириллических букв, используемых в автономерах
const LOOKALIKE_LETTERS: Record<string, string> = {
	a: 'а',
	b: 'в',
	e: 'е',
	k: 'к',
	m: 'м',
	h: 'н',
	o: 'о',
	p: 'р',
	c: 'с',
	t: 'т',
	y: 'у',
	x: 'х',
};

// Приводит номер к нижнему регистру, убирает пробелы и унифицирует алфавит,
// чтобы он находился независимо от раскладки (латиница/кириллица)
export const normalizeCarNumber = (value: string | undefined | null) =>
	(value ?? '')
		.toLowerCase()
		.replace(/\s+/g, '')
		.replace(/[a-z]/g, (char) => LOOKALIKE_LETTERS[char] ?? char);

// Кириллические двойники латинских букв автономера
const CYRILLIC_TO_LATIN: Record<string, string> = {
	А: 'A',
	В: 'B',
	Е: 'E',
	К: 'K',
	М: 'M',
	Н: 'H',
	О: 'O',
	Р: 'P',
	С: 'C',
	Т: 'T',
	У: 'Y',
	Х: 'X',
};

// Переводит автономер в латиницу верхнего регистра — формат, который принимает
// маска ввода CarInput (для номеров, хранящихся в кириллице — иначе маска их отбрасывает)
export const carNumberToLatin = (value: string | undefined | null) =>
	(value ?? '').toUpperCase().replace(/[А-Я]/g, (char) => CYRILLIC_TO_LATIN[char] ?? char);
